// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles_desktop_scss_v2_legacy_darkmode__darkmode-dir_scss":"409199d7c6e2fb299c31","styles_desktop_scss_v2_legacy_components_game-window__game-window-dir_scss":"f1ad2029d70e4ce0113a","styles_mobile_scss_v2_legacy_darkmode__darkmode-dir_scss":"bf2a0336ef03aacb797f"}[chunkId] + ".css";
};